// removed by extract-text-webpack-plugin
module.exports = {"reset-success-wrapper":"index__reset-success-wrapper___1MfnM","reset-container":"index__reset-container___1xqD9","reset-content":"index__reset-content___3TOD4","title":"index__title___3d_oM","content-text":"index__content-text___2lDak","login-btn":"index__login-btn___1saSP","content-second":"index__content-second___3HKBI"};


//////////////////
// WEBPACK FOOTER
// ./src/views/Auth/HasBeenRest/index.less
// module id = 1826
// module chunks = 3